import { Grid, IconButton } from '@mui/material';
import FormCitizenship from './form';
import { Fragment, memo, useMemo } from 'react';
import { HeadCell } from 'shell/components/shared/table/types';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import { Delete } from '@mui/icons-material';
import Table from 'shell/components/shared/table-person';
import { DateTime } from 'luxon';

interface CitizenshipFormProps {
  headCells: HeadCell<CitizenshipVM, keyof CitizenshipVM>[];
  onAddToTable: (values: Array<CitizenshipVM>) => void;
  citizens?: Array<CitizenshipVM>;
  onDelete: (value: CitizenshipVM) => void;
  isEditMode?: boolean;
  dateControl?: DateTime | null;
  disabled?: boolean;
  numberMaxCitizenship?: number;
  error?: boolean;
  messaggeError?: string;
}

const CitizenshipFormComponent = ({
  headCells,
  onAddToTable,
  citizens = [],
  onDelete,
  isEditMode,
  disabled = false,
  dateControl,
  numberMaxCitizenship,
  error = false,
  messaggeError = '',
}: CitizenshipFormProps): React.ReactElement => {
  const citizensTable: Array<CitizenshipVM> | undefined = useMemo(() => {
    return citizens?.map((citizen) => ({
      ...citizen,
      action: (
        <Fragment>
          <IconButton disabled={disabled} color="cdmBrand" onClick={() => onDelete(citizen)}>
            <Delete />
          </IconButton>
        </Fragment>
      ),
    }));
  }, [citizens, onDelete, disabled]);

  return (
    <Grid container spacing={1}>
      <FormCitizenship
        onAdd={onAddToTable}
        citizens={citizens || []}
        isEditMode={isEditMode}
        dateControl={dateControl}
        numberMaxCitizenship={numberMaxCitizenship}
      />
      <Grid item xs={12}>
        <Table head={headCells} body={citizensTable || []} ariaLabel="Lista Cittadinanza" />
      </Grid>
      {error && messaggeError ? (
        <Grid item xs={12}>
          {messaggeError}
        </Grid>
      ) : undefined}
    </Grid>
  );
};

CitizenshipFormComponent.displayName = 'Citizenship Form and table component';

const CitizenshipForm = memo(CitizenshipFormComponent);

export default CitizenshipForm;
